<template>
  <div class="row">
    <div class="col-12">
      <h1 class="mt-0 mb-2">Zmiana hasła</h1>

      <p v-if="isPasswordExpired">
        Twoje hasło wygasło. Należy ustawić nowe hasło, aby kontynuować korzystanie z aplikacji.
      </p>

      <password-form
        with-current-password
        :show-cancel-button="!isPasswordExpired"
        @setPassword="updatePassword"
        @cancel="goToHome"
      />
    </div>
  </div>
</template>

<script>
import moment from 'moment';

import PasswordForm from '@/components/forms/PasswordForm';
import { notificationsMixin } from '@/mixins/notifications';
import { serverError } from '@/utils/serverError';
import { getTokenData } from '@/utils/tokenData';

// @vuese
// Komponent do wymuszonej zmiany hasła
// @group user
export default {
  components: { PasswordForm },

  mixins: [notificationsMixin],

  computed: {
    isPasswordExpired() {
      const passwordExpireDate = getTokenData()?.user?.passwordValidUntil;
      return passwordExpireDate && moment().isAfter(passwordExpireDate);
    }
  },

  methods: {
    // @vuese
    // Zmiana hasła
    updatePassword(passwordData) {
      this.$store
        .dispatch('auth/setPasswordLogged', passwordData)
        .then(() => this.goToHome())
        .catch(err => this.notifyError(serverError(err)));
    },

    // @vuese
    // Przejście na widok po zalogowaniu
    goToHome() {
      this.$router.push({ name: 'myProfile' });
    }
  }
};
</script>
